import React from 'react'
import { Footer, Navbar, Product, AnnouncementBar } from "../components"

const Products = () => {
  return (
    <>
  <AnnouncementBar />
  <Navbar />
      <Product />
      <Footer />
    </>
  )
}

export default Products